import React, { useEffect, useState } from "react";
import { X, GitCompare, ArrowRight } from "lucide-react";
import { api, extractErrorMessage } from "@/lib/api";

const tl = (v) => (v == null ? "—" : `${Number(v).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺`);

function Row({ r }) {
  const up = r.fark > 0;
  return (
    <tr className="border-t border-slate-100" data-testid={`compare-row-${r.personnel_id}`}>
      <td className="px-3 py-2">
        <div className="font-semibold text-slate-900">{r.ad_soyad}</div>
        <div className="text-[11px] text-slate-500">{r.pozisyon}</div>
      </td>
      <td className="px-3 py-2 text-right font-mono-tab text-slate-600">{tl(r.onceki?.net_maas)}</td>
      <td className="px-1 text-slate-300"><ArrowRight size={12} /></td>
      <td className="px-3 py-2 text-right font-mono-tab text-slate-900">{tl(r.simdiki?.net_maas)}</td>
      <td className={`px-3 py-2 text-right font-mono-tab font-bold ${up ? "text-emerald-700" : "text-rose-700"}`}>{up ? "+" : ""}{tl(r.fark)}</td>
      <td className="px-3 py-2">
        <div className="flex flex-wrap gap-1">
          {r.nedenler.map((n) => <span key={n} className="text-[10px] font-semibold bg-slate-100 text-slate-700 px-1.5 py-0.5 rounded">{n}</span>)}
        </div>
        {r.onceki && r.simdiki && r.onceki.maas !== r.simdiki.maas && (
          <div className="text-[10px] text-slate-500 mt-0.5">Maaş: {tl(r.onceki.maas)} → {tl(r.simdiki.maas)}</div>
        )}
      </td>
    </tr>
  );
}

export function PayrollCompareModal({ yil, ay, onClose }) {
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get("/payroll/compare", { params: { yil, ay } }).then((r) => setD(r.data)).catch((e) => setErr(extractErrorMessage(e, "Karşılaştırma yüklenemedi")));
  }, [yil, ay]);
  return (
    <div className="fixed inset-0 z-50 bg-slate-900/50 flex items-center justify-center p-4" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="bg-white rounded-xl shadow-xl w-full max-w-5xl max-h-[88vh] flex flex-col" data-testid="payroll-compare-modal">
        <div className="p-4 border-b border-slate-200 flex items-center gap-2">
          <GitCompare size={16} />
          <h3 className="font-bold text-slate-900 flex-1">Bordro Karşılaştırma {d ? `· ${d.onceki_donem} → ${d.donem}` : ""}</h3>
          <button onClick={onClose} data-testid="payroll-compare-close" className="p-1 rounded hover:bg-slate-100"><X size={16} /></button>
        </div>
        {err && <div className="p-4 text-sm text-rose-700">{err}</div>}
        {!d && !err && <div className="p-6 text-sm text-slate-500">Hesaplanıyor…</div>}
        {d && (
          <>
            <div className="px-4 py-3 flex flex-wrap gap-4 text-xs bg-slate-50 border-b border-slate-200" data-testid="payroll-compare-summary">
              <span>Önceki toplam net: <b className="font-mono-tab">{tl(d.onceki_toplam)}</b></span>
              <span>Bu ay toplam net: <b className="font-mono-tab">{tl(d.simdiki_toplam)}</b></span>
              <span>Fark: <b className="font-mono-tab">{d.simdiki_toplam > d.onceki_toplam ? "+" : ""}{tl(d.simdiki_toplam - d.onceki_toplam)}</b></span>
              <span>Değişen personel: <b>{d.degisen}</b></span>
            </div>
            <div className="overflow-auto">
              {d.rows.length === 0 ? <div className="p-6 text-sm text-slate-500">İki ay arasında net maaşı değişen personel yok.</div> : (
                <table className="w-full text-sm">
                  <thead className="text-[11px] uppercase tracking-wider text-slate-500 bg-white sticky top-0">
                    <tr><th className="px-3 py-2 text-left">Personel</th><th className="px-3 py-2 text-right">{d.onceki_donem}</th><th /><th className="px-3 py-2 text-right">{d.donem}</th><th className="px-3 py-2 text-right">Fark</th><th className="px-3 py-2 text-left">Neden</th></tr>
                  </thead>
                  <tbody>{d.rows.map((r) => <Row key={r.personnel_id} r={r} />)}</tbody>
                </table>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
